import { doc, getDoc, serverTimestamp, runTransaction } from 'firebase/firestore';
import { browserLocalPersistence, setPersistence, signInAnonymously } from 'firebase/auth';
import { auth, db } from '../firebase';

export async function authenticateParticipant() {
  await setPersistence(auth, browserLocalPersistence);
  await auth.authStateReady();
  const user = auth.currentUser || (await signInAnonymously(auth)).user;
  return user;
}

export async function openSession() {
  const user = await authenticateParticipant();
  const snapshot = await getDoc(doc(db, 'survey_data', user.uid));
  return { sessionId: user.uid, checkpoint: snapshot.exists() ? snapshot.data() : null };
}

export async function saveCheckpoint(sessionId, checkpoint, revision) {
  if (!auth.currentUser || auth.currentUser.uid !== sessionId) {
    throw Object.assign(new Error('Session owner mismatch'), { code: 'session/unauthorized' });
  }
  const reference = doc(db, 'survey_data', sessionId);
  await runTransaction(db, async transaction => {
    const snapshot = await transaction.get(reference);
    const currentRevision = snapshot.exists() ? snapshot.data().revision : 0;
    if (currentRevision !== revision) {
      throw Object.assign(new Error('Checkpoint changed in another tab'), { code: 'session/conflict' });
    }
    transaction.set(reference, {
      ...checkpoint, owner_uid: sessionId, revision: revision + 1,
      timestamp: serverTimestamp()
    });
  });
}

export function describeError(error) {
  const messages = {
    'permission-denied': '저장 권한이 없습니다. 연구자가 Firestore 보안 규칙을 확인해야 합니다.',
    'auth/operation-not-allowed': '익명 인증이 비활성화되어 있습니다. 연구자가 Firebase Authentication 설정을 확인해야 합니다.',
    'auth/configuration-not-found': 'Firebase Authentication 설정이 필요합니다. 연구자에게 문의해주세요.',
    'auth/unauthorized-domain': '현재 접속 주소가 Firebase 인증에서 허용되지 않습니다. 연구자에게 문의해주세요.',
    'auth/network-request-failed': '인증 서버에 연결하지 못했습니다. 인터넷 연결을 확인하고 다시 시도해주세요.',
    'session/conflict': '다른 탭에서 진행 기록이 변경되었습니다. 이 페이지를 새로고침해 저장된 지점에서 이어주세요.',
    'session/unauthorized': '인증 세션이 변경되었습니다. 페이지를 새로고침해주세요.'
  };
  return messages[error.code] || '서버에 연결하거나 저장하지 못했습니다. 인터넷 연결을 확인한 뒤 다시 시도해주세요.';
}
